export const InitialDataTbSetColour = () => {
    return {
        Colour_Id: null,
        comp_id: window.localStorage.getItem('company'),
        Colour_Code: null,
        Colour_Name: null,
        Colour_Status: "Y"
    }
}
